import { useNavigate } from "react-router-dom";
import img2 from "../assets/img/home_img/banh-trang-2.jpg";
import { useTranslation } from "react-i18next";

const Special = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("special");
  return (
    <div className="bg-gradient-to-b from-yellow-50 to-white py-16 max-w-xxl">
      {/* Header */}
      <div className="text-center mb-10">
        <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3 tracking-wide">
          {t("signature_food")}{" "}
          <span className="text-yellow-500">Mantic Cup</span>
        </h1>
        <div className="flex justify-center">
          <span className="block border-b-4 border-yellow-500 w-20 rounded-full"></span>
        </div>
      </div>

      {/* Content Section */}
      <div className="flex flex-col md:flex-row items-center justify-between max-w-xxl mx-auto px-6 md:px-12 gap-10">
        {/* Image Section */}
        <div className="relative w-full md:w-1/2 flex justify-center">
          <div className="absolute -top-6 -left-6 w-24 h-24 bg-yellow-400 rounded-full opacity-30 blur-2xl"></div>
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-yellow-200 rounded-full opacity-20 blur-3xl"></div>
          <img
            src={img2}
            alt="Signature Dish"
            className="
    w-56 sm:w-64 md:w-80 lg:w-96
    rounded-2xl shadow-xl object-cover
    transform transition duration-500
    hover:scale-105 hover:shadow-2xl
  "
          />
        </div>

        {/* Text Section */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 leading-tight">
            {t("food_name")}
          </h2>
          <p className="text-gray-600 text-base mb-6 leading-relaxed">
            {t("desc_food")}
          </p>

          <button
            onClick={() => navigate("/menu")}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-3 px-8 rounded-full flex items-center gap-2 mx-auto md:mx-0 transition-all duration-300 shadow-md hover:shadow-lg"
          >
            <span>{t("order_now")}</span>
            <span className="text-xl">🛒</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Special;
